import React from "react";

export interface ChangeEntry {
  version: string;
  changes: string[];
}

export const CHANGELOG_DATA: ChangeEntry[] = [
  {
    version: "2.47.9",
    changes: ["Improved error reporting."],
  },
  {
    version: "2.47.8",
    changes: ["Improved security measures for token generation."],
  },
  {
    version: "2.47.7",
    changes: ["Fixed bug in Data analysis mode.", "Improved user navigation."],
  },
  {
    version: "2.47.6",
    changes: ["Expanded customer functionality."],
  },
  {
    version: "2.47.5",
    changes: [
      "Modified custom financial modeling sorting options.",
      "Enhanced login security.",
    ],
  },
  {
    version: "2.47.4",
    changes: [
      "Fixed bug in error component.",
      "Fixed bug in several API endpoints.",
    ],
  },
  {
    version: "2.47.3",
    changes: [
      "Added styling options.",
      "Fixed bug in password reset functionality.",
    ],
  },
  {
    version: "2.47.2",
    changes: [
      "Added Admin functionality.",
      "Changed routing mechanism.",
      "Minor style changes.",
    ],
  },
  {
    version: "2.47.1",
    changes: [
      "Disabled UI changes.",
      'Added "incoming maintenance" message capabilities.',
    ],
  },
  {
    version: "2.47.0",
    changes: [
      "Modified UI links and verbosity.",
      "Updated data display capabilities for custom charts.",
    ],
  },
];

export const ChangeLog: React.FC = () => {
  return (
    <section className="changelog">
      <h2 className="changelog__title">Application Change Log</h2>

      <div className="changelog__list">
        {CHANGELOG_DATA.map(({ version, changes }) => (
          <article key={version} className="changelog__card">
            <header className="changelog__header">
              <span className="changelog__badge">{version}</span>
            </header>

            <ul className="changelog__items">
              {changes.map((c, idx) => (
                <li key={idx} className="changelog__item">
                  {c}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};
